unit View.Subgrupos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewSubgruposEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbgrupo_id: TLabel;
    edgrupo_id: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientSubgruposGet: TXDataWebClient;
    XDataClientSubgruposDelete: TXDataWebClient;
    SubgruposDataset: TXDataWebDataSet;
    SubgruposDatasetid: TIntegerField;
    SubgruposDatasetaliado_id: TIntegerField;
    SubgruposDatasetdata_base_id: TIntegerField;
    SubgruposDatasetnome: TStringField;
    SubgruposDatasetgrupo_id: TIntegerField;
    SubgruposDatasetcodigo_interno: TIntegerField;
    SubgruposDatasetexcluido: TBooleanField;
    SubgruposDatasetinclusao: TDateTimeField;
    SubgruposDatasetalteracao: TDateTimeField;
    SubgruposDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientSubgruposGetLoad(Response: TXDataClientResponse);
    procedure XDataClientSubgruposDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientSubgruposDeleteError(Error: TXDataClientError);
    procedure SubgruposDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewSubgruposEdit: TFViewSubgruposEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSubgruposEdit }

procedure TFViewSubgruposEdit.btSaveClick(Sender: TObject);
begin
  if SubgruposDataset.State in dsEditModes then
  begin
        SubgruposDataset.Post;
    SubgruposDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewSubgruposEdit.btDeleteClick(Sender: TObject);
begin
  if SubgruposDataset.State in dsEditModes then
    SubgruposDataset.Post;
  XDataClientSubgruposDelete.Delete(SubgruposDataset.EntitySetName,
    TJSObject(SubgruposDataset.CurrentData));
end;


class function TFViewSubgruposEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSubgruposEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewSubgruposEdit.InsertEntity;
begin
  SubgruposDataset.Close;
  SubgruposDataset.SetJsonData('{}');
  SubgruposDataset.Open;
  SubgruposDataset.Insert;
end;

class function TFViewSubgruposEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSubgruposEdit(AForm).FInserting := AInserting;
    TFViewSubgruposEdit(AForm).FId := AId;
    TFViewSubgruposEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSubgruposEdit(AForm).InsertEntity
    else
      TFViewSubgruposEdit(AForm).LoadEntity;
    TFViewSubgruposEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewSubgruposEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSubgruposEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    SubgruposDataset.Connection.Model.DefaultSchema.FindEntityType(
      SubgruposDataset.EntitySetName
    )
  );
  XDataClientSubgruposGet.Get(SubgruposDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSubgruposEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewSubgruposEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSubgruposEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSubgruposEdit.XDataClientSubgruposGetLoad(Response: TXDataClientResponse);
begin
  SubgruposDataset.Close;
  SubgruposDataset.SetJsonData(Response.Result);
  SubgruposDataset.Open;
  
  SubgruposDataset.Edit;  
end;

procedure TFViewSubgruposEdit.XDataClientSubgruposDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewSubgruposEdit.XDataClientSubgruposDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewSubgruposEdit.SubgruposDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewSubgruposEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSubgruposEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.subgrupos.form.message');
  lbMessage := TLabel.Create('view.subgrupos.form.message.label');
  btCloseMessage := TButton.Create('view.subgrupos.form.message.button');
  btCancel := TButton.Create('view.subgrupos.form.btBack');
  btSave := TButton.Create('view.subgrupos.form.btSave');
  btDelete := TButton.Create('view.subgrupos.form.btDelete');
  lbid := TLabel.Create('view.subgrupos.form.lbid');
  edid := TDBEdit.Create('view.subgrupos.form.edid');
  lbaliado_id := TLabel.Create('view.subgrupos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.subgrupos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.subgrupos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.subgrupos.form.eddata_base_id');
  lbnome := TLabel.Create('view.subgrupos.form.lbnome');
  ednome := TDBEdit.Create('view.subgrupos.form.ednome');
  lbgrupo_id := TLabel.Create('view.subgrupos.form.lbgrupo_id');
  edgrupo_id := TDBEdit.Create('view.subgrupos.form.edgrupo_id');
  lbcodigo_interno := TLabel.Create('view.subgrupos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.subgrupos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.subgrupos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.subgrupos.form.edexcluido');
  lbinclusao := TLabel.Create('view.subgrupos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.subgrupos.form.edinclusao');
  lbalteracao := TLabel.Create('view.subgrupos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.subgrupos.form.edalteracao');
  lbexclusao := TLabel.Create('view.subgrupos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.subgrupos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  SubgruposDataset := TXDataWebDataSet.Create(Self);
  SubgruposDatasetid := TIntegerField.Create(Self);
  SubgruposDatasetaliado_id := TIntegerField.Create(Self);
  SubgruposDatasetdata_base_id := TIntegerField.Create(Self);
  SubgruposDatasetnome := TStringField.Create(Self);
  SubgruposDatasetgrupo_id := TIntegerField.Create(Self);
  SubgruposDatasetcodigo_interno := TIntegerField.Create(Self);
  SubgruposDatasetexcluido := TBooleanField.Create(Self);
  SubgruposDatasetinclusao := TDateTimeField.Create(Self);
  SubgruposDatasetalteracao := TDateTimeField.Create(Self);
  SubgruposDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientSubgruposGet := TXDataWebClient.Create(Self);
  XDataClientSubgruposDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbgrupo_id.BeforeLoadDFMValues;
  edgrupo_id.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  SubgruposDataset.BeforeLoadDFMValues;
  SubgruposDatasetid.BeforeLoadDFMValues;
  SubgruposDatasetaliado_id.BeforeLoadDFMValues;
  SubgruposDatasetdata_base_id.BeforeLoadDFMValues;
  SubgruposDatasetnome.BeforeLoadDFMValues;
  SubgruposDatasetgrupo_id.BeforeLoadDFMValues;
  SubgruposDatasetcodigo_interno.BeforeLoadDFMValues;
  SubgruposDatasetexcluido.BeforeLoadDFMValues;
  SubgruposDatasetinclusao.BeforeLoadDFMValues;
  SubgruposDatasetalteracao.BeforeLoadDFMValues;
  SubgruposDatasetexclusao.BeforeLoadDFMValues;
  XDataClientSubgruposGet.BeforeLoadDFMValues;
  XDataClientSubgruposDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewSubgruposEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbgrupo_id.SetParentComponent(Self);
    lbgrupo_id.Name := 'lbgrupo_id';
    lbgrupo_id.Left := 24;
    lbgrupo_id.Top := 300;
    lbgrupo_id.Width := 14;
    lbgrupo_id.Height := 13;
    lbgrupo_id.Caption := 'grupo_id:';
    lbgrupo_id.Transparent := True;
    edgrupo_id.SetParentComponent(Self);
    edgrupo_id.Name := 'edgrupo_id';
    edgrupo_id.Left := 221;
    edgrupo_id.Top := 297;
    edgrupo_id.Width := 200;
    edgrupo_id.Height := 21;
    edgrupo_id.Enabled := True;
    edgrupo_id.TabOrder := 10;
    edgrupo_id.Text := 'edgrupo_id';
    edgrupo_id.DataField := 'grupo_id';
    edgrupo_id.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 327;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 324;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 11;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 354;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 351;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 12;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 408;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 405;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 14;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 435;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 432;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 15;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := SubgruposDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    SubgruposDataset.SetParentComponent(Self);
    SubgruposDataset.Name := 'SubgruposDataset';
    SubgruposDataset.AfterApplyUpdates := SubgruposDatasetAfterApplyUpdates;
    SubgruposDataset.EntitySetName := 'Subgrupos';
    SubgruposDataset.Connection := DMConnection.ApiConnection;
    SubgruposDataset.Left := 176;
    SubgruposDataset.Top := 8;
    SubgruposDatasetid.SetParentComponent(SubgruposDataset);
    SubgruposDatasetid.Name := 'SubgruposDatasetid';
    SubgruposDatasetid.FieldName := 'id';
    SubgruposDatasetid.Required := True;
    SubgruposDatasetaliado_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetaliado_id.Name := 'SubgruposDatasetaliado_id';
    SubgruposDatasetaliado_id.FieldName := 'aliado_id';
    SubgruposDatasetaliado_id.Required := True;
    SubgruposDatasetdata_base_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetdata_base_id.Name := 'SubgruposDatasetdata_base_id';
    SubgruposDatasetdata_base_id.FieldName := 'data_base_id';
    SubgruposDatasetdata_base_id.Required := True;
    SubgruposDatasetnome.SetParentComponent(SubgruposDataset);
    SubgruposDatasetnome.Name := 'SubgruposDatasetnome';
    SubgruposDatasetnome.FieldName := 'nome';
    SubgruposDatasetnome.Required := True;
    SubgruposDatasetnome.Size := 255;
    SubgruposDatasetgrupo_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetgrupo_id.Name := 'SubgruposDatasetgrupo_id';
    SubgruposDatasetgrupo_id.FieldName := 'grupo_id';
    SubgruposDatasetgrupo_id.Required := True;
    SubgruposDatasetcodigo_interno.SetParentComponent(SubgruposDataset);
    SubgruposDatasetcodigo_interno.Name := 'SubgruposDatasetcodigo_interno';
    SubgruposDatasetcodigo_interno.FieldName := 'codigo_interno';
    SubgruposDatasetcodigo_interno.Required := True;
    SubgruposDatasetexcluido.SetParentComponent(SubgruposDataset);
    SubgruposDatasetexcluido.Name := 'SubgruposDatasetexcluido';
    SubgruposDatasetexcluido.FieldName := 'excluido';
    SubgruposDatasetexcluido.Required := False;
    SubgruposDatasetinclusao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetinclusao.Name := 'SubgruposDatasetinclusao';
    SubgruposDatasetinclusao.FieldName := 'inclusao';
    SubgruposDatasetinclusao.Required := False;
    SubgruposDatasetalteracao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetalteracao.Name := 'SubgruposDatasetalteracao';
    SubgruposDatasetalteracao.FieldName := 'alteracao';
    SubgruposDatasetalteracao.Required := False;
    SubgruposDatasetexclusao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetexclusao.Name := 'SubgruposDatasetexclusao';
    SubgruposDatasetexclusao.FieldName := 'exclusao';
    SubgruposDatasetexclusao.Required := False;
    XDataClientSubgruposGet.SetParentComponent(Self);
    XDataClientSubgruposGet.Name := 'XDataClientSubgruposGet';
    XDataClientSubgruposGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSubgruposGet, Self, 'OnLoad', 'XDataClientSubgruposGetLoad');
    XDataClientSubgruposGet.Left := 64;
    XDataClientSubgruposGet.Top := 8;
    XDataClientSubgruposDelete.SetParentComponent(Self);
    XDataClientSubgruposDelete.Name := 'XDataClientSubgruposDelete';
    XDataClientSubgruposDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSubgruposDelete, Self, 'OnLoad', 'XDataClientSubgruposDeleteLoad');
    SetEvent(XDataClientSubgruposDelete, Self, 'OnError', 'XDataClientSubgruposDeleteError');
    XDataClientSubgruposDelete.Left := 64;
    XDataClientSubgruposDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbgrupo_id.AfterLoadDFMValues;
    edgrupo_id.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    SubgruposDataset.AfterLoadDFMValues;
    SubgruposDatasetid.AfterLoadDFMValues;
    SubgruposDatasetaliado_id.AfterLoadDFMValues;
    SubgruposDatasetdata_base_id.AfterLoadDFMValues;
    SubgruposDatasetnome.AfterLoadDFMValues;
    SubgruposDatasetgrupo_id.AfterLoadDFMValues;
    SubgruposDatasetcodigo_interno.AfterLoadDFMValues;
    SubgruposDatasetexcluido.AfterLoadDFMValues;
    SubgruposDatasetinclusao.AfterLoadDFMValues;
    SubgruposDatasetalteracao.AfterLoadDFMValues;
    SubgruposDatasetexclusao.AfterLoadDFMValues;
    XDataClientSubgruposGet.AfterLoadDFMValues;
    XDataClientSubgruposDelete.AfterLoadDFMValues;
  end;
end;

end.
